import React from 'react';
import {Route} from 'react-router-dom';
import {AppContext} from './Context';
// import PropTypes from "prop-types";
// import history from "./history";

export default class PublicRoute extends React.Component {
  state = {
    componentMounted: false,
  };
  componentDidMount() {
    //
    // this.requireAuth();
  }

  async requireAuth() {
    // let res = await this.context.authenticationService.requireAuth();
    // this.setState({ componentMounted: true });
  }
  render() {
    let {component: Component} = this.props;
    return (
      <Route
        render={(props) => (
          <Component {...props} match={this.props.computedMatch} />
        )}
      />
    );
  }
}

PublicRoute.contextType = AppContext;
